module.exports = __webpack_public_path__ + "static/media/sales_campaign_bannar.f37f09a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/sales_campaign_bannar.png
// module id = 516
// module chunks = 0